import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppConfig } from '../../app-config';

@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  constructor(private httpClient: HttpClient, private apiUrl: AppConfig) { }

  public calendarAPI = (startDate: any, endDate: any): Observable<any> => {
    return this.httpClient.get<any>(
      this.apiUrl.teacherApiURL.calendarAPI +
      '?start_date=' +
      startDate +
      '&end_date=' +
      endDate
    );
  };
  public updateAvailabilityAPI = (requestData: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherApiURL.updateAvailabilityAPI,
      requestData
    );
  };
  public recurringDatesMatchAPI = (requestData: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherApiURL.recurringDatesMatchAPI,
      requestData
    );
  };
  public calendarStatsAPI = (month: any, year: any): Observable<any> => {
    return this.httpClient.get<any>(
      this.apiUrl.teacherApiURL.calendarStatsAPI +
      '?month=' +
      month +
      '&year=' +
      year
    );
  };
  calendarbookingDetailsAPI = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(
      this.apiUrl.teacherApiURL.calendarbookingDetailsAPI,
      { params: filterData }
    );
  };

  cancelBookingsAPI = (filterData: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherApiURL.cancelBookingsAPI,
      filterData
    );
  };
  updateExternalBookingsAPI = (filterData: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherApiURL.updateExternalBookingsAPI,
      filterData
    );
  };
  updateQuickAvailabilityAPI = (filterData: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherApiURL.updateQuickAvailabilityAPI,
      filterData
    );
  };
  deleteUpdateBookingAPI = (filterData: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherApiURL.deleteUpdateBookingAPI,
      filterData
    );
  };
}
